import { TASK_STATUSES, TASK_STATUS_LABEL, taskStatusColor } from '../../lib/taskStatus'

export function StatusLegend() {
  return (
    <div
      className="flex flex-wrap gap-x-4 gap-y-1.5 text-xs text-muted"
      role="note"
      aria-label="Leyenda de colores por estado"
    >
      {TASK_STATUSES.map((status) => {
        const color = taskStatusColor(status)
        return (
          <span key={status} className="flex items-center gap-1.5">
            <span className={`h-2.5 w-2.5 rounded-full ${color.dot}`} aria-hidden />
            {TASK_STATUS_LABEL[status]}
          </span>
        )
      })}
    </div>
  )
}
